import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {AllowedCountryAndCurrencyApiResponse} from '../types';

export const allowedCountryAndCurrencyMock: AllowedCountryAndCurrencyApiResponse = {
  countries: ['CZE', 'DEU', 'AUT', 'POL'],
  currencies: ['CZK', 'EUR', 'PLN'],
};

const getAllowedCountryAndCurrencyResponseInterceptor = (
  server: SetupServerApi,
  mockData: AllowedCountryAndCurrencyApiResponse = allowedCountryAndCurrencyMock
) =>
  server.use(
    http.get('*/dms/v*/sourcing/allowed-country-and-currency', () => HttpResponse.json(mockData))
  );

export const sourcingApiMock = {
  allowedCountryAndCurrencyMock,
  getAllowedCountryAndCurrencyResponseInterceptor,
};
